import React, { memo } from "react";

import styled from "styled-components";

type StyledImageProps = {
  dataId: string;
  src: string;
  alt?: string;
};

const StyledImg = styled.img(() => ({
  "&&": {
    margin: "0 auto",
    width: "100%",
  },
}));

export const StyledImage = memo(({ dataId, src, alt }: StyledImageProps) => {
  return <StyledImg src={src} alt={alt} data-testid={dataId} />;
});
